import { untilComplete } from "@pjs/observables";
import { patchAccountSettings } from "../functions/PatchAccountSettings.function";
import { requestBodyMapper } from "../mappers/RequestBodyMapper.function";
import { trackSaveAnalytics } from "../functions/TrackSaveAnalytics.function";
import { accountSettings } from "../consts/AccountSettings.const";
import { AccountSettingState } from "../enums/AccountSettingState";

export const saveSettingsEffect = (): void => {
    const document = accountSettings.getDocument();
    const patches = document.getChanges();
    const bodyData = requestBodyMapper(patches);
    if (bodyData.length === 0) {
        return;
    }

    document.latestModel.state.update({ descriptor: AccountSettingState.SavePending });

    const patchTo = patches.at(-1);
    patchAccountSettings(bodyData)
        .pipe(untilComplete(document.changeStream))
        .subscribe({
            error: () => document.latestModel.state.update({ descriptor: AccountSettingState.SaveFailed }),
            next: () => {
                trackSaveAnalytics(bodyData);
                document.applyChanges(patchTo?.id);
                document.latestModel.state.update({ descriptor: AccountSettingState.SaveSuccess });
                location.reload();
            }
        });
};
